export enum InspectionResultAccessor {
  defect = 'defect',
  fieldValue = 'fieldValue',
  defectOrFieldValue = 'defectOrFieldValue',
  fieldValueWithOnTopOfProtocolPdf = 'fieldValueWithOnTopOfProtocolPdf',
}
